import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/constants";
import { shuffle } from "../../utils/common";

export const getProducts = createAsyncThunk(
  'products/getProducts',
  async (_,thunkAPI) => {
    try {
      const res = await axios(`${BASE_URL}/products`);
        return res.data;
    } catch(err) {
      console.log(err)
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при завантаженні товарів');
    }
  }
);

export const createProduct = createAsyncThunk(
  'products/createProduct',
  async (formData, thunkAPI) => {
    try {
      const res = await axios.post(`${BASE_URL}/products`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (!res.data || typeof res.data !== 'object' || !res.data.id) {
        throw new Error('Некоректна відповідь сервера при збереженні товару');
      }
      return res.data;
    } catch(err) {
      console.log(err)
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при завантаженні товарів');
    }
  }
);

export const updateProduct = createAsyncThunk(
  'products/updateProduct',
  async ({ id, formData }, thunkAPI) => {
    try {
      const res = await axios.post(`${BASE_URL}/products/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (!res.data || typeof res.data !== 'object' || !res.data.id) {
        throw new Error('Некоректна відповідь сервера при збереженні товару');
      }
      return res.data;
    } catch(err) {
      console.log(err)
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при завантаженні товарів');
    }
  }
);

export const deleteProduct = createAsyncThunk(
  'products/deleteProduct',
  async (id, thunkAPI) => {
    try {
      await axios.delete(`${BASE_URL}/products/${id}`);
      return id;
    } catch(err) {
      console.log(err)
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при завантаженні товарів');
    }
  }
);

const productsSlice = createSlice({
  name: "products",
  initialState: {
    list: [],
    filtered: [],
    related: [],
    isLoading: false,
  },
  reducers: {
    filterByPrice: (state, { payload }) => {
      state.filtered = state.list.filter(({ price }) => price < payload);
    },
    getRelatedProducts: (state, { payload }) => {
      const list = state.list.filter(({ category: { id } }) => id === payload);
      state.related = shuffle(list);
    },
    patchProductInList: (state, { payload }) => {
      const { id, ...fields } = payload;
      const index = state.list.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.list[index] = { ...state.list[index], ...fields };
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProducts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getProducts.fulfilled, (state, { payload }) => {
      const prevMap = new Map(state.list.map((item) => [item.id, item]));
      state.list = payload.map((item) => {
        const normalized = {
          ...item,
          isVerified: Object.prototype.hasOwnProperty.call(item, 'isVerified')
            ? Boolean(item.isVerified)
            : Boolean(prevMap.get(item.id)?.isVerified),
        };
        return normalized;
      });
      state.isLoading = false;
    });
    builder.addCase(getProducts.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createProduct.fulfilled, (state, { payload }) => {
      state.list.push(payload);
    });
    builder.addCase(updateProduct.fulfilled, (state, { payload }) => {
      const index = state.list.findIndex(item => item.id === payload.id);
      if (index !== -1) {
        state.list[index] = {
          ...state.list[index],
          ...payload,
          isVerified: Object.prototype.hasOwnProperty.call(payload, 'isVerified')
            ? Boolean(payload.isVerified)
            : state.list[index].isVerified,
        };
      }
    });
    builder.addCase(deleteProduct.fulfilled, (state, { payload }) => {
      state.list = state.list.filter(item => item.id !== payload);
    });
  },
});

export const { filterByPrice, getRelatedProducts, patchProductInList } = productsSlice.actions;

export default productsSlice.reducer;
